<template>
	<div>
		<header>
			<div style="display: block;">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">
							<div>{{$t('xitongxx')}}</div>
						</div>
						<div class="action" @click="changego">
							<text class="cuIcon-back" style="width: 50px;">
								<span></span>
							</text>
						</div>
					</div>
				</div>
			</div>
		</header>
		<div style="padding: 0px 5px;">
			<div class="bg-gradual-black padding" style="margin-top: 5px; border-radius: 12px;"
				v-for="(notice, index) in notices" :key="index">
				<div class=" text-sm flex">
					<div class="action">
						<div class="text-green text-xs">{{ formatTime(notice.createtime) }}
						</div>
					</div>
					<div class="margin-left text-gold" style="overflow: auto;text-align: left;">
						<text>
							<span>{{ notice.memo}}</span>
						</text>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import userApi from "@/api/user";
	export default {
		name: "MoreNews",
		components: {},
		data() {
			return {
				active: 0,
				tops: null,
				articleTabs: null,
				notices: [],

			};
		},
		methods: {
			formatTime(timestamp) {
				const date = new Date(timestamp * 1000)
				const month = (date.getMonth() + 1).toString().padStart(2, '0')
				const day = date.getDate().toString().padStart(2, '0')
				const year = date.getFullYear()
				return `${month}/${day}/${year}`
			},

			changego() {
				this.$router.go(-1);
			},
			info() {
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 0,
				});
				userApi
					.sendMessageUser()
					.then((data) => {
						// console.log(data, 21221);
						this.notices = data.data.articleTabs;
						// console.log(this.notices, 4533);
						// this.articleTabs = data.data.articleTabs;
						this.$toast.clear();
					})
					.catch((err) => {
						this.$toast.clear();
						this.$toast.fail(err.msg);
					});
			},

		},
		mounted() {},
		created() {
			this.info();

		},
	};
</script>

<style>
	.settingwarp {
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
	}

	.warpnotice {
		height: 100%;
	}

	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.padding {
		padding: 17px;
	}

	.text-sm {
		font-size: 13px;
	}

	.flex {
		display: flex;
	}

	.text-green,
	.line-green,
	.lines-green {
		color: #39b54a;
	}

	.text-xs {
		font-size: 11px;
	}

	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.margin-left {
		margin-left: 17px;
	}

	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}
</style>